// import { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';

// const useLanguage = () => {
//   const { i18n, t } = useTranslation();
//   const [currentLang, setCurrentLang] = useState(i18n.language);

//   useEffect(() => {
//     const handleLanguageChange = (lng) => {
//       setCurrentLang(lng);
//     };

//     i18n.on('languageChanged', handleLanguageChange);

//     return () => {
//       i18n.off('languageChanged', handleLanguageChange);
//     };
//   }, [i18n]);
//   const isEngLang=currentLang==='en'


//   return {
//     currentLang,
//     t,
//     isEngLang
//   }
// };

// export default useLanguage;


import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useReduxStore from './useReduxStore';
import moment from 'moment-timezone';
import 'moment/locale/ar';
const useLanguage = () => {
  const { i18n, t } = useTranslation();
  const { selector: language } = useReduxStore("language");
  const currentLang = language?.lang || 'en';

  // Set i18n language if different from Redux
  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang, i18n]);

  // Update document direction based on language
  useEffect(() => {
    document.documentElement.setAttribute('dir', i18n.dir(currentLang));
    moment.locale(currentLang);
  }, [currentLang, i18n]);

  return {
    currentLang,
    isEngLang: currentLang === 'en',
    isRTL: currentLang === 'ar',
    t,
  };
};

export default useLanguage;
